export default __webpack_public_path__ + "static/dreamreality-solid-1273809596b39f118d4f650b281d58d2.png";